module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/public/login/select_un.png";